<template>
  <div
    class="modal product-modal fade"
    id="productModal"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-fullscreen">
      <div class="modal-content">
        <div class="modal-body p-0">
          <div
            class="modal-body-product-content bg-white m-auto position-relative"
            v-if="singleProduct"
          >
            <img
              src="@/img/modal_close.png"
              data-bs-dismiss="modal"
              class="modal-close pointer d-none d-md-block"
              @click="removeProductParam()"
            />
            <img
              src="@/img/modal_close_mb.png"
              data-bs-dismiss="modal"
              class="modal-close-mb pointer d-md-none"
              @click="removeProductParam()"
            />
            <div class="row product-row">
              <div class="col-lg-5 col-12 p-0">
                <div class="product-img-col">
                  <div
                    class="product-img-big mb-4 d-none d-lg-block"
                    :style="{
                      background: 'url(' + singleProduct.main_image + ')',
                    }"
                  ></div>
                  <ModalProductSlick v-bind:singleProduct="singleProduct" />
                </div>
              </div>
              <div class="col-lg-7 col-12 p-0">
                <div class="product-content mx-5">
                  <!-- <div>
                    <span class="font-16 text-theme-2"
                      >Heartwarming Gift Set | 精美礼盒配套</span
                    >
                  </div> -->
                  <div class="product-name">
                    <span class="font-24 fw-bold">{{
                      singleProduct.name
                    }}</span>
                  </div>
                  <div class="py-2">
                    <span class="font-24 fw-bold text-theme-3"
                      >{{ priceUnit
                      }}{{ Number(singleProduct.price) | currencyFormat }}</span
                    >
                  </div>
                  <div class="product-modal-product-variations">
                    <!-- <ul>
                      <li>1 x Fruits Yogurt Cubes 80g</li>
                      <li>
                        2 x Premium Freeze Dried Fruits (Mango 40g / Dragon
                        Fruit 45g)
                      </li>
                      <li>
                        2 x Premium Freeze Dried Fruits (Mango 40g / Dragon
                        Fruit 45g)
                      </li>
                    </ul> -->
                    <p class="font-16" v-html="singleProduct.description"></p>
                  </div>

                  
                  <!-- <div class="free-gift pt-3">
                    <span class="font-18 fw-bold text-uppercase"
                      >Free Gift</span
                    >
                    <ul class="pt-1">
                      <li>1 X SMALL PACK VEGGIE</li>
                      <li>1 X RAYA CARD</li>
                      <li>1 X RAYA CARD</li>
                    </ul>
                  </div>  -->
                  <p class="font-14 fst-italic text-theme-2 py-3" v-show="singleProduct.stock_quantity"
                  v-if="singleProduct.stock_status == 'instock'"
                  >
                    Hurry! only {{ singleProduct.stock_quantity }} left in stock.
                  </p>

                  <!-- With Variation -->
                  <div class="divider" v-show="singleProduct.selections.length > 0"></div>
                  <div class="flavor-variations" v-show="singleProduct.selections.length > 0"
                  v-if="singleProduct.stock_status == 'instock'">
                    <p class="font-18 fw-bold text-uppercase">
                      Please choose your flavors:
                    </p>
                    <form>
                      <div class="pb-4" v-for="(selection, sindex) in singleProduct.selections" :key="sindex">
                        <label :for="'p' + singleProduct.id + '-s' + selection.id" class="form-label"
                          >{{ selection.name }}</label
                        >
                        {{ (selection.selected_option == null) ? selection.selected_option='' : ''}}
                        <select :id="'p' + singleProduct.id + '-s' + selection.id" class="form-select form-control" v-model="selection.selected_option">
                          <option value="" selected="true" disabled>
                            Choose an option
                          </option>
                          <option :value="option" v-for="(option, oindex) in selection.options" :key="oindex" v-html="option"></option>
                        </select>
                      </div>
                      <p class="variant-error-msg" v-show="showVariantErrorMsg">Please select your flavour. </p>                     
                    </form>
                  </div>
                  <div class="divider" v-show="singleProduct.selections.length > 0"></div>
                  <!-- End With Variation -->

                  <div class="addtocart-option d-flex align-items-center pt-3">
                    <div
                      class="add-remove-option bg-white d-flex align-items-center me-md-4"
                      v-if="singleProduct.stock_status == 'instock'"
                    >
                      <div
                        class="py-3 px-4 pointer text-center"
                        @click="reduceQuantity(singleProduct)"
                      >
                        <img src="@/img/product/minus.png" width="11px;" />
                      </div>
                      <div class="no-item-added py-3 px-4 pointer text-center">
                        <span class="font-16 fw-bold">{{
                          singleProduct.quantity
                        }}</span>
                      </div>
                      <div
                        class="py-3 px-4 pointer text-center"
                        @click="increaseQuantity(singleProduct)"
                      >
                        <img src="@/img/product/plus.png" width="11px;" />
                      </div>
                    </div>
                    <!--After user add item to cart, the Add to cart button background will become green, just add the class "itemadded" in button tag-->
                    <div>
                      <button
                        class="btn py-3 px-5 itemadded add_to_cart_modal_btn"
                        :id="'product-' + singleProduct.sku"
                        v-if="singleProduct.stock_status == 'instock'"
                        @click="addToCart(singleProduct)"
                      >
                        <span class="font-16 fw-bold text-white add_to_cart_modal_btn"
                        :id="'product-' + singleProduct.sku + '-text'"
                          >Add to cart</span
                        >
                      </button>
                      <!-- if product out of stock -->
                      <button
                        class="btn py-3 px-5 itemadded"
                        v-else
                        disabled
                      >
                        <span class="font-16 fw-bold text-white"
                          >Out of stock</span
                        >
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalProductSlick from "./ModalProductSlick.vue";

export default {
  name: "ProductModal",
  props: ["singleProduct", "priceUnit", "showVariantErrorMsg"],
  components: {
    ModalProductSlick,
  },
  filters: {
    currencyFormat: function (value) {
      let val = value.toFixed(2);
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  methods: {
    increaseQuantity: function (itemToIncrease) {
      this.$parent.increaseQuantity(itemToIncrease);
    },
    reduceQuantity: function (itemToReduce) {
      this.$parent.reduceQuantity(itemToReduce);
    },
    addToCart: function (itemToAdd) {
      this.$parent.addToCart(itemToAdd);
      this.$parent.removeProductParam();
    },
    removeProductParam: function () {
      this.$parent.removeProductParam();
    },
  },
};
</script>

<style scoped>
.variant-error-msg {
  color: red;
  font-size: 1.4rem;
}
</style>